const byId = <T extends HTMLElement = HTMLElement>(id: string): T => {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element #${id}`);
  return el as T;
};

export const els = {
  form: byId<HTMLFormElement>("controls"),
  style: byId<HTMLSelectElement>("style"), styleNote: byId("styleNote"),
  count: byId<HTMLInputElement>("count"), countLabel: byId("countLabel"),
  unitWeight: byId<HTMLInputElement>("unitWeight"), unitLabel: byId("unitLabel"),
  yeast: byId<HTMLSelectElement>("yeast"), sourdoughOpts: byId("sourdoughOpts"),
  sdMode: byId<HTMLSelectElement>("sdMode"), starterHyd: byId<HTMLInputElement>("starterHyd"),
  time: byId<HTMLInputElement>("time"), timeOut: byId("timeOut"),
  timeChips: byId("timeChips"), timeFlag: byId("timeFlag"), slipProof: byId("slipProof"),
  temp: byId<HTMLInputElement>("temp"), tempOut: byId("tempOut"), tempChips: byId("tempChips"),
  yeastPct: byId<HTMLInputElement>("yeastPct"), yeastPctLabel: byId("yeastPctLabel"),
  resetYeast: byId<HTMLButtonElement>("resetYeast"), autoNote: byId("autoNote"),
  hydration: byId<HTMLInputElement>("hydration"), salt: byId<HTMLInputElement>("salt"),
  oil: byId<HTMLInputElement>("oil"), sugar: byId<HTMLInputElement>("sugar"),
  butter: byId<HTMLInputElement>("butter"), butterField: byId("butterField"),
  slipStyle: byId("slipStyle"), slipMeta: byId("slipMeta"),
  ingredients: byId("ingredients"), totalOut: byId("totalOut"), warn: byId("warn"),
  methodSteps: byId("methodSteps"),
  saveBtn: byId<HTMLButtonElement>("saveBtn"), saved: byId("saved"),
  historyList: byId("historyList"), clearHistory: byId<HTMLButtonElement>("clearHistory"),
  copyLink: byId<HTMLButtonElement>("copyLink"),
  printBtn: byId<HTMLButtonElement>("printBtn"),
  wakeToggle: byId<HTMLInputElement>("wakeToggle"),
  wakeWrap: byId("wakeWrap"),
  unitToggle: byId("unitToggle"),
  volWarn: byId("volWarn"),
};
